import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/item-hrchies", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/item-hrchies", params);
};

const getByConfig = params => {
  return restApi.get("/api/item-hrchies/config", { params });
};

const getHrchyFilter = params => {
  return restApi.get("/api/item-hrchies/filter", { params });
};

const get = id => {
  return restApi.get(`/api/item-hrchies/${id}`);
};

const upsert = data => {
  return restApi.post("/api/item-hrchies/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/item-hrchies/${ids}`);
};

const getLookup = params => {
  return restApi.get("/api/item-hrchies/leaf", { params })
};

const getHrchyClsr = () => {
  return restApi.get("/api/item-hrchyClsr");
};

const getTopHrchy = params => {
  return restApi.get("/api/item-hrchies/top", { params });
};

const itemHrchyService = {
  getAll,
  getAllForCSV,
  getByConfig,
  getHrchyFilter,
  get,
  upsert,
  remove,
  getLookup,
  getHrchyClsr,
  getTopHrchy
};

export default itemHrchyService;